// extracted by mini-css-extract-plugin
export default {"navbar":"app_navbar__OcY0t"};